
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/detailPackage",
      function () {
        return require("private-next-pages/product/detailPackage.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/detailPackage"])
      });
    }
  